import { values } from 'lodash'

import { createOptionsFromEnum } from '../utils/createOptionsFromEnum'

export const RACE_TYPE = {
  trekking: 'trekking',
  snowshoeTrekking: 'snowshoeTrekking',
  glacierHiking: 'glacierHiking',
  viaFerrata: 'viaFerrata',
  skiMountaineering: 'skiMountaineering',
  iceFall: 'iceFall',
  snowIceRacing: 'snowIceRacing',
  largeSportsPath: 'largeSportsPath',
  largeAdventurePlayground: 'largeAdventurePlayground',
  mixedRace: 'mixedRace',
  mountainField: 'mountainField',
  crossingEquipment: 'crossingEquipment',
  OTHER: 'OTHER',
}

export const RACE_TYPE_ARRAY = values(RACE_TYPE)

export const RACE_TYPE_OPTIONS = createOptionsFromEnum({ values: values(RACE_TYPE), prefix: 'raceType' })
